import axios from "axios";

import { TextSnippetListModel, TextSnippetDetailModel, TextSnippetFilter } from "./model";

class TextSnippetApi {

    private readonly apiUrl = "/api/textSnippet";
    private getAllCancelTokenSource = axios.CancelToken.source(); // eslint-disable-line import/no-named-as-default-member

    public async getAll(filter?: TextSnippetFilter): Promise<TextSnippetListModel[]> {
        this.getAllCancelTokenSource.cancel("Cancelled to allow subsequent request");
        this.getAllCancelTokenSource = axios.CancelToken.source(); // eslint-disable-line import/no-named-as-default-member
        const response = await axios.get(this.apiUrl, { params: filter, cancelToken: this.getAllCancelTokenSource.token });
        const data = response.data as TextSnippetListModel[];
        return data.map(this.parseModel);
    }

    public parseModel(model: TextSnippetDetailModel): TextSnippetDetailModel {
        return {
            ...model
        };
    }
}

export const textSnippetApi = new TextSnippetApi();
